module.exports = __webpack_public_path__ + "img/icon_progressive.007b6020.png";